module.exports = __webpack_public_path__ + "media/src/images/icons/star/inactive-0bb6eaa48acdf5ccb8941e114006d100.svg";